import React from "react";
import Com from "components/styledComp/CommStyledComp";

const benefits = [
  {
    label: "관리 효율",
    value: "최대 80%",
    description: "데이터 입력과 관리에 필요한 운영 리소스를 절감합니다.",
  },
  {
    label: "빠른 온보딩",
    value: "약 10분",
    description: "직원 100명 등록과 권한 부여를 빠르게 처리합니다.",
  },
  {
    label: "운영 단순화",
    value: "서버 구축 0",
    description: "별도 서버 구축 없이 클라우드 동기화와 자동 업데이트를 제공합니다.",
  },
];

const SaaSBenefits = () => {
  return (
    <Com.DivDetailSection>
      <Com.DivDetailHeading>
        <Com.DetailHeading>클라우드 도입 효과</Com.DetailHeading>
        <Com.DetailHeadingSmall>
          기술 역량을 실제 운영 효율과 빠른 서비스 전환으로 연결합니다
        </Com.DetailHeadingSmall>
      </Com.DivDetailHeading>
      <Com.DivMetricGrid>
        {benefits.map((benefit) => (
          <Com.ArticleMetricCard key={benefit.label}>
            <Com.SpanMetricLabel>{benefit.label}</Com.SpanMetricLabel>
            <Com.StrongMetricValue>{benefit.value}</Com.StrongMetricValue>
            <Com.PMetricDescription>{benefit.description}</Com.PMetricDescription>
          </Com.ArticleMetricCard>
        ))}
      </Com.DivMetricGrid>
    </Com.DivDetailSection>
  );
};

export default SaaSBenefits;
